import { IApiClient } from '../data/client';
import { GetModularConfigurationByCodeQuery } from '../data/model';
import ModularConfiguratorPageQuery from '../modularConfigurator/ModularConfiguratorPageQuery';
import { StoreUrl } from './StoreUrl';
import { RelativeUrl } from './Url';

export class ModularConfiguratorUrlBuilder {
  private client: IApiClient;

  constructor(client: IApiClient) {
    this.client = client;
  }

  public async buildFromCode(code: string): Promise<RelativeUrl> {
    const {
      modularConfigurationData: { productFamilyId },
    } = await this.client.send(new GetModularConfigurationByCodeQuery({ modularCode: code }));

    return StoreUrl.modularConfiguratorUrl(productFamilyId, new ModularConfiguratorPageQuery('', code));
  }
}
